import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English',    nativeLabel: 'English',    dir: 'ltr', flag: '🇬🇧' },
  { code: 'ar', label: 'Arabic',     nativeLabel: 'العربية',    dir: 'rtl', flag: '🇸🇦' },
  { code: 'zh', label: 'Chinese',    nativeLabel: '中文',        dir: 'ltr', flag: '🇨🇳' },
  { code: 'tr', label: 'Turkish',    nativeLabel: 'Türkçe',     dir: 'ltr', flag: '🇹🇷' },
  { code: 'de', label: 'German',     nativeLabel: 'Deutsch',    dir: 'ltr', flag: '🇩🇪' },
  { code: 'fr', label: 'French',     nativeLabel: 'Français',   dir: 'ltr', flag: '🇫🇷' },
  { code: 'hi', label: 'Hindi',      nativeLabel: 'हिन्दी',       dir: 'ltr', flag: '🇮🇳' },
  { code: 'it', label: 'Italian',    nativeLabel: 'Italiano',   dir: 'ltr', flag: '🇮🇹' },
];

export const RTL_LANGUAGES = ['ar'];

const resources = {
  en: { translation: {
    app_name: 'OSESG', tagline: 'Your Trusted Global B2B Trade Platform',
    tagline_long: 'Connect with verified manufacturers, get competitive quotes, and manage your entire supply chain in one place.',
    search: 'What are you looking for? Try: CNC machine, solar panel...',
    search_products: 'Search products...',
    login: 'Login', register: 'Register', logout: 'Logout',
    dashboard: 'Dashboard', products: 'Products', orders: 'Orders',
    messages: 'Messages', notifications: 'Notifications', settings: 'Settings',
    profile: 'Profile', save: 'Save', cancel: 'Cancel', delete: 'Delete',
    edit: 'Edit', view: 'View', submit: 'Submit', approve: 'Approve',
    reject: 'Reject', loading: 'Loading...', no_results: 'No results found',
    email: 'Email', password: 'Password', first_name: 'First Name', last_name: 'Last Name',
    phone: 'Phone', country: 'Country', city: 'City', address: 'Address',
    forgot_password: 'Forgot Password?', create_account: 'Create Account',
    already_have_account: 'Already have an account?',
    all_products: 'All Products', product_details: 'Product Details',
    request_quote: 'Request Quote', add_product: 'Add Product',
    product_code: 'Product Code', price: 'Price', moq: 'Minimum Order Quantity',
    lead_time: 'Lead Time', specifications: 'Specifications',
    applications: 'Applications', advantages: 'Advantages',
    order_number: 'Order Number', order_status: 'Order Status', order_total: 'Total',
    place_order: 'Place Order', track_order: 'Track Order',
    send_message: 'Send Message', type_message: 'Type a message...',
    contact_support: 'Contact Support', ai_assistant: 'AI Assistant',
    admin_dashboard: 'Admin Dashboard', manage_suppliers: 'Manage Suppliers',
    manage_products: 'Manage Products', manage_orders: 'Manage Orders',
    manage_users: 'Manage Users', content_approval: 'Content Approval',
    violations: 'Violations', analytics: 'Analytics', escrow: 'Escrow',
    supplier_dashboard: 'Supplier Dashboard', my_products: 'My Products',
    incoming_orders: 'Incoming Orders', quotes: 'Quotes',
    customer_dashboard: 'My Dashboard', my_orders: 'My Orders',
    my_quotes: 'My Quotes', shipment_tracking: 'Shipment Tracking',
    payment_methods: 'Payment Methods', my_cart: 'My Cart',
    language: 'Language', choose_language: 'Choose Language',
    main_site: 'Main Site', admin_panel: 'Admin Panel', my_account: 'My Account',
    why_choose: 'Why Choose OSESG?',
    show_original: 'Show original', show_translation: 'Show translation',
    translated_from: 'Translated from {{lang}}',
    translating: 'Translating...',
    language_saved: 'Language preference saved',
    cnc_machines: 'CNC Machines', solar_panels: 'Solar Panels',
    forklifts: 'Forklifts', electronics: 'Electronics', medical_equipment: 'Medical Equipment',
  }},
  ar: { translation: {
    app_name: 'OSESG', tagline: 'منصّتك الموثوقة للتجارة العالمية بين الشركات',
    tagline_long: 'تواصَل مع مصنّعين موثّقين، واحصل على عروض أسعار تنافسية، وأدِر سلسلة التوريد بالكامل من مكان واحد.',
    search: 'عمّ تبحث؟ جرّب: ماكينة CNC، لوح طاقة شمسية...',
    search_products: 'ابحث عن المنتجات...',
    login: 'تسجيل الدخول', register: 'إنشاء حساب', logout: 'تسجيل الخروج',
    dashboard: 'لوحة التحكّم', products: 'المنتجات', orders: 'الطلبات',
    messages: 'الرسائل', notifications: 'الإشعارات', settings: 'الإعدادات',
    profile: 'الملف الشخصي', save: 'حفظ', cancel: 'إلغاء', delete: 'حذف',
    edit: 'تعديل', view: 'عرض', submit: 'إرسال', approve: 'موافقة',
    reject: 'رفض', loading: 'جارٍ التحميل...', no_results: 'لا توجد نتائج',
    email: 'البريد الإلكتروني', password: 'كلمة المرور', first_name: 'الاسم الأول',
    last_name: 'اسم العائلة', phone: 'الهاتف', country: 'الدولة', city: 'المدينة',
    address: 'العنوان', forgot_password: 'هل نسيت كلمة المرور؟',
    create_account: 'إنشاء حساب', already_have_account: 'هل لديك حساب بالفعل؟',
    all_products: 'جميع المنتجات', product_details: 'تفاصيل المنتج',
    request_quote: 'طلب عرض سعر', add_product: 'إضافة منتج',
    product_code: 'رمز المنتج', price: 'السعر', moq: 'الحد الأدنى للطلب',
    lead_time: 'مدة التسليم', specifications: 'المواصفات',
    applications: 'الاستخدامات', advantages: 'المزايا',
    order_number: 'رقم الطلب', order_status: 'حالة الطلب', order_total: 'الإجمالي',
    place_order: 'تأكيد الطلب', track_order: 'تتبّع الطلب',
    send_message: 'إرسال رسالة', type_message: 'اكتب رسالة...',
    contact_support: 'تواصل مع الدعم', ai_assistant: 'المساعد الذكي',
    admin_dashboard: 'لوحة تحكّم الإدارة', manage_suppliers: 'إدارة المورّدين',
    manage_products: 'إدارة المنتجات', manage_orders: 'إدارة الطلبات',
    manage_users: 'إدارة المستخدمين', content_approval: 'اعتماد المحتوى',
    violations: 'المخالفات', analytics: 'التقارير والتحليلات', escrow: 'الضمان',
    supplier_dashboard: 'لوحة تحكّم المورّد', my_products: 'منتجاتي',
    incoming_orders: 'الطلبات الواردة', quotes: 'عروض الأسعار',
    customer_dashboard: 'لوحة تحكّمي', my_orders: 'طلباتي',
    my_quotes: 'عروض الأسعار الخاصة بي', shipment_tracking: 'تتبّع الشحنات',
    payment_methods: 'طرق الدفع', my_cart: 'سلّة المشتريات',
    language: 'اللغة', choose_language: 'اختر اللغة',
    main_site: 'الصفحة الرئيسية', admin_panel: 'لوحة الإدارة', my_account: 'حسابي',
    why_choose: 'لماذا OSESG؟',
    show_original: 'عرض النص الأصلي', show_translation: 'عرض الترجمة',
    translated_from: 'مُترجَم من {{lang}}',
    translating: 'جارٍ الترجمة...',
    language_saved: 'تم حفظ تفضيل اللغة',
    cnc_machines: 'ماكينات CNC', solar_panels: 'الألواح الشمسية',
    forklifts: 'الرافعات الشوكية', electronics: 'الإلكترونيات', medical_equipment: 'المعدات الطبية',
  }},
  zh: { translation: {
    app_name: 'OSESG', tagline: '值得信赖的全球 B2B 贸易平台',
    tagline_long: '与经过认证的制造商直接对接，获取具有竞争力的报价，一站式管理您的整个供应链。',
    search: '您想找什么？试试：数控机床、太阳能板……',
    search_products: '搜索产品...',
    login: '登录', register: '注册', logout: '退出登录',
    dashboard: '控制面板', products: '产品', orders: '订单',
    messages: '消息', notifications: '通知', settings: '设置',
    profile: '个人资料', save: '保存', cancel: '取消', delete: '删除',
    edit: '编辑', view: '查看', submit: '提交', approve: '批准',
    reject: '拒绝', loading: '加载中...', no_results: '未找到结果',
    email: '电子邮箱', password: '密码', first_name: '名', last_name: '姓',
    phone: '电话', country: '国家', city: '城市', address: '地址',
    forgot_password: '忘记密码？', create_account: '创建账户',
    already_have_account: '已有账户？',
    all_products: '全部产品', product_details: '产品详情',
    request_quote: '索取报价', add_product: '添加产品',
    product_code: '产品编号', price: '价格', moq: '最小起订量',
    lead_time: '交货期', specifications: '规格参数',
    applications: '适用场景', advantages: '产品优势',
    order_number: '订单号', order_status: '订单状态', order_total: '合计',
    place_order: '提交订单', track_order: '追踪订单',
    send_message: '发送消息', type_message: '输入消息...',
    contact_support: '联系客服', ai_assistant: 'AI 智能助手',
    admin_dashboard: '管理控制台', manage_suppliers: '供应商管理',
    manage_products: '产品管理', manage_orders: '订单管理',
    manage_users: '用户管理', content_approval: '内容审核',
    violations: '违规记录', analytics: '数据分析', escrow: '资金托管',
    supplier_dashboard: '供应商控制台', my_products: '我的产品',
    incoming_orders: '新收到的订单', quotes: '报价单',
    customer_dashboard: '我的控制台', my_orders: '我的订单',
    my_quotes: '我的报价', shipment_tracking: '物流追踪',
    payment_methods: '付款方式', my_cart: '我的购物车',
    language: '语言', choose_language: '选择语言',
    main_site: '返回首页', admin_panel: '管理后台', my_account: '我的账户',
    why_choose: '为什么选择 OSESG？',
    show_original: '查看原文', show_translation: '查看译文',
    translated_from: '译自 {{lang}}',
    translating: '翻译中...',
    language_saved: '语言偏好已保存',
    cnc_machines: '数控机床', solar_panels: '太阳能电池板',
    forklifts: '叉车', electronics: '电子产品', medical_equipment: '医疗设备',
  }},
  tr: { translation: {
    app_name: 'OSESG', tagline: 'Güvenilir Küresel B2B Ticaret Platformunuz',
    tagline_long: 'Doğrulanmış üreticilerle bağlantı kurun, rekabetçi teklifler alın ve tüm tedarik zincirinizi tek bir yerden yönetin.',
    search: 'Ne arıyorsunuz? Örn: CNC makinesi, güneş paneli...',
    search_products: 'Ürünleri ara...',
    login: 'Giriş Yap', register: 'Kayıt Ol', logout: 'Çıkış Yap',
    dashboard: 'Kontrol Paneli', products: 'Ürünler', orders: 'Siparişler',
    messages: 'Mesajlar', notifications: 'Bildirimler', settings: 'Ayarlar',
    profile: 'Profil', save: 'Kaydet', cancel: 'İptal', delete: 'Sil',
    edit: 'Düzenle', view: 'Görüntüle', submit: 'Gönder', approve: 'Onayla',
    reject: 'Reddet', loading: 'Yükleniyor...', no_results: 'Sonuç bulunamadı',
    email: 'E-posta', password: 'Şifre', first_name: 'Ad', last_name: 'Soyad',
    phone: 'Telefon', country: 'Ülke', city: 'Şehir', address: 'Adres',
    forgot_password: 'Şifrenizi mi unuttunuz?', create_account: 'Hesap Oluştur',
    already_have_account: 'Zaten hesabınız var mı?',
    all_products: 'Tüm Ürünler', product_details: 'Ürün Detayları',
    request_quote: 'Teklif Al', add_product: 'Ürün Ekle',
    product_code: 'Ürün Kodu', price: 'Fiyat', moq: 'Minimum Sipariş Miktarı',
    lead_time: 'Teslimat Süresi', specifications: 'Teknik Özellikler',
    applications: 'Kullanım Alanları', advantages: 'Avantajlar',
    order_number: 'Sipariş Numarası', order_status: 'Sipariş Durumu', order_total: 'Toplam',
    place_order: 'Siparişi Ver', track_order: 'Siparişi Takip Et',
    send_message: 'Mesaj Gönder', type_message: 'Bir mesaj yazın...',
    contact_support: 'Destek Hattı', ai_assistant: 'Yapay Zekâ Asistanı',
    admin_dashboard: 'Yönetici Paneli', manage_suppliers: 'Tedarikçi Yönetimi',
    manage_products: 'Ürün Yönetimi', manage_orders: 'Sipariş Yönetimi',
    manage_users: 'Kullanıcı Yönetimi', content_approval: 'İçerik Onayı',
    violations: 'İhlaller', analytics: 'Analiz', escrow: 'Emanet Hesabı',
    supplier_dashboard: 'Tedarikçi Paneli', my_products: 'Ürünlerim',
    incoming_orders: 'Gelen Siparişler', quotes: 'Teklifler',
    customer_dashboard: 'Panelim', my_orders: 'Siparişlerim',
    my_quotes: 'Tekliflerim', shipment_tracking: 'Kargo Takibi',
    payment_methods: 'Ödeme Yöntemleri', my_cart: 'Sepetim',
    language: 'Dil', choose_language: 'Dil Seçin',
    main_site: 'Ana Sayfa', admin_panel: 'Yönetim Paneli', my_account: 'Hesabım',
    why_choose: 'Neden OSESG?',
    show_original: 'Orijinali göster', show_translation: 'Çeviriyi göster',
    translated_from: '{{lang}} dilinden çevrildi',
    translating: 'Çevriliyor...',
    language_saved: 'Dil tercihi kaydedildi',
    cnc_machines: 'CNC Tezgâhları', solar_panels: 'Güneş Panelleri',
    forklifts: 'Forkliftler', electronics: 'Elektronik', medical_equipment: 'Tıbbi Cihazlar',
  }},
  de: { translation: {
    app_name: 'OSESG', tagline: 'Ihre vertrauenswürdige globale B2B-Handelsplattform',
    tagline_long: 'Verbinden Sie sich mit geprüften Herstellern, erhalten Sie wettbewerbsfähige Angebote und verwalten Sie Ihre gesamte Lieferkette an einem Ort.',
    search: 'Wonach suchen Sie? Versuchen Sie: CNC-Maschine, Solarmodul...',
    search_products: 'Produkte suchen...',
    login: 'Anmelden', register: 'Registrieren', logout: 'Abmelden',
    dashboard: 'Übersicht', products: 'Produkte', orders: 'Bestellungen',
    messages: 'Nachrichten', notifications: 'Benachrichtigungen', settings: 'Einstellungen',
    profile: 'Profil', save: 'Speichern', cancel: 'Abbrechen', delete: 'Löschen',
    edit: 'Bearbeiten', view: 'Ansehen', submit: 'Absenden', approve: 'Genehmigen',
    reject: 'Ablehnen', loading: 'Wird geladen...', no_results: 'Keine Ergebnisse gefunden',
    email: 'E-Mail', password: 'Passwort', first_name: 'Vorname', last_name: 'Nachname',
    phone: 'Telefon', country: 'Land', city: 'Stadt', address: 'Adresse',
    forgot_password: 'Passwort vergessen?', create_account: 'Konto erstellen',
    already_have_account: 'Sie haben bereits ein Konto?',
    all_products: 'Alle Produkte', product_details: 'Produktdetails',
    request_quote: 'Angebot anfordern', add_product: 'Produkt hinzufügen',
    product_code: 'Artikelnummer', price: 'Preis', moq: 'Mindestbestellmenge',
    lead_time: 'Lieferzeit', specifications: 'Technische Daten',
    applications: 'Einsatzbereiche', advantages: 'Vorteile',
    order_number: 'Bestellnummer', order_status: 'Bestellstatus', order_total: 'Gesamtsumme',
    place_order: 'Bestellung aufgeben', track_order: 'Bestellung verfolgen',
    send_message: 'Nachricht senden', type_message: 'Nachricht eingeben...',
    contact_support: 'Support kontaktieren', ai_assistant: 'KI-Assistent',
    admin_dashboard: 'Admin-Dashboard', manage_suppliers: 'Lieferanten verwalten',
    manage_products: 'Produkte verwalten', manage_orders: 'Bestellungen verwalten',
    manage_users: 'Benutzer verwalten', content_approval: 'Inhaltsfreigabe',
    violations: 'Verstöße', analytics: 'Auswertungen', escrow: 'Treuhand',
    supplier_dashboard: 'Lieferanten-Dashboard', my_products: 'Meine Produkte',
    incoming_orders: 'Eingehende Bestellungen', quotes: 'Angebote',
    customer_dashboard: 'Mein Dashboard', my_orders: 'Meine Bestellungen',
    my_quotes: 'Meine Angebote', shipment_tracking: 'Sendungsverfolgung',
    payment_methods: 'Zahlungsmethoden', my_cart: 'Mein Warenkorb',
    language: 'Sprache', choose_language: 'Sprache wählen',
    main_site: 'Startseite', admin_panel: 'Admin-Bereich', my_account: 'Mein Konto',
    why_choose: 'Warum OSESG?',
    show_original: 'Original anzeigen', show_translation: 'Übersetzung anzeigen',
    translated_from: 'Übersetzt aus {{lang}}',
    translating: 'Wird übersetzt...',
    language_saved: 'Spracheinstellung gespeichert',
    cnc_machines: 'CNC-Maschinen', solar_panels: 'Solarmodule',
    forklifts: 'Gabelstapler', electronics: 'Elektronik', medical_equipment: 'Medizintechnik',
  }},
  fr: { translation: {
    app_name: 'OSESG', tagline: 'Votre plateforme mondiale de confiance pour le commerce B2B',
    tagline_long: "Connectez-vous avec des fabricants vérifiés, obtenez des devis compétitifs et gérez toute votre chaîne d'approvisionnement au même endroit.",
    search: 'Que recherchez-vous ? Essayez : machine CNC, panneau solaire...',
    search_products: 'Rechercher des produits...',
    login: 'Connexion', register: "S'inscrire", logout: 'Déconnexion',
    dashboard: 'Tableau de bord', products: 'Produits', orders: 'Commandes',
    messages: 'Messages', notifications: 'Notifications', settings: 'Paramètres',
    profile: 'Profil', save: 'Enregistrer', cancel: 'Annuler', delete: 'Supprimer',
    edit: 'Modifier', view: 'Voir', submit: 'Envoyer', approve: 'Approuver',
    reject: 'Refuser', loading: 'Chargement...', no_results: 'Aucun résultat',
    email: 'E-mail', password: 'Mot de passe', first_name: 'Prénom', last_name: 'Nom',
    phone: 'Téléphone', country: 'Pays', city: 'Ville', address: 'Adresse',
    forgot_password: 'Mot de passe oublié ?', create_account: 'Créer un compte',
    already_have_account: 'Vous avez déjà un compte ?',
    all_products: 'Tous les produits', product_details: 'Détails du produit',
    request_quote: 'Demander un devis', add_product: 'Ajouter un produit',
    product_code: 'Code produit', price: 'Prix', moq: 'Quantité minimale',
    lead_time: 'Délai de livraison', specifications: 'Spécifications',
    applications: 'Applications', advantages: 'Avantages',
    order_number: 'N° de commande', order_status: 'Statut de la commande', order_total: 'Total',
    place_order: 'Passer commande', track_order: 'Suivre la commande',
    send_message: 'Envoyer un message', type_message: 'Écrire un message...',
    contact_support: 'Contacter le support', ai_assistant: 'Assistant IA',
    admin_dashboard: "Tableau d'administration", manage_suppliers: 'Gérer les fournisseurs',
    manage_products: 'Gérer les produits', manage_orders: 'Gérer les commandes',
    manage_users: 'Gérer les utilisateurs', content_approval: 'Validation du contenu',
    violations: 'Infractions', analytics: 'Analyses', escrow: 'Séquestre',
    supplier_dashboard: 'Tableau fournisseur', my_products: 'Mes produits',
    incoming_orders: 'Commandes reçues', quotes: 'Devis',
    customer_dashboard: 'Mon tableau de bord', my_orders: 'Mes commandes',
    my_quotes: 'Mes devis', shipment_tracking: 'Suivi des expéditions',
    payment_methods: 'Moyens de paiement', my_cart: 'Mon panier',
    language: 'Langue', choose_language: 'Choisir la langue',
    main_site: 'Site principal', admin_panel: 'Espace admin', my_account: 'Mon compte',
    why_choose: 'Pourquoi choisir OSESG ?',
    show_original: "Afficher l'original", show_translation: 'Afficher la traduction',
    translated_from: 'Traduit du {{lang}}',
    translating: 'Traduction en cours...',
    language_saved: 'Préférence de langue enregistrée',
    cnc_machines: 'Machines CNC', solar_panels: 'Panneaux solaires',
    forklifts: 'Chariots élévateurs', electronics: 'Électronique', medical_equipment: 'Équipements médicaux',
  }},
  hi: { translation: {
    app_name: 'OSESG', tagline: 'आपका भरोसेमंद वैश्विक B2B व्यापार मंच',
    tagline_long: 'सत्यापित निर्माताओं से जुड़ें, प्रतिस्पर्धी कोटेशन पाएँ और अपनी पूरी आपूर्ति-श्रृंखला एक ही जगह से संभालें।',
    search: 'आप क्या खोज रहे हैं? जैसे: CNC मशीन, सोलर पैनल...',
    search_products: 'उत्पाद खोजें...',
    login: 'लॉगिन', register: 'रजिस्टर करें', logout: 'लॉगआउट',
    dashboard: 'डैशबोर्ड', products: 'उत्पाद', orders: 'ऑर्डर',
    messages: 'संदेश', notifications: 'सूचनाएँ', settings: 'सेटिंग्स',
    profile: 'प्रोफ़ाइल', save: 'सहेजें', cancel: 'रद्द करें', delete: 'हटाएँ',
    edit: 'संपादित करें', view: 'देखें', submit: 'जमा करें', approve: 'स्वीकृत करें',
    reject: 'अस्वीकार करें', loading: 'लोड हो रहा है...', no_results: 'कोई परिणाम नहीं मिला',
    email: 'ईमेल', password: 'पासवर्ड', first_name: 'पहला नाम', last_name: 'अंतिम नाम',
    phone: 'फ़ोन', country: 'देश', city: 'शहर', address: 'पता',
    forgot_password: 'पासवर्ड भूल गए?', create_account: 'खाता बनाएँ',
    already_have_account: 'क्या आपके पास पहले से खाता है?',
    all_products: 'सभी उत्पाद', product_details: 'उत्पाद विवरण',
    request_quote: 'कोटेशन माँगें', add_product: 'उत्पाद जोड़ें',
    product_code: 'उत्पाद कोड', price: 'क़ीमत', moq: 'न्यूनतम ऑर्डर मात्रा',
    lead_time: 'डिलीवरी समय', specifications: 'विनिर्देश',
    applications: 'उपयोग', advantages: 'लाभ',
    order_number: 'ऑर्डर संख्या', order_status: 'ऑर्डर स्थिति', order_total: 'कुल',
    place_order: 'ऑर्डर दें', track_order: 'ऑर्डर ट्रैक करें',
    send_message: 'संदेश भेजें', type_message: 'संदेश लिखें...',
    contact_support: 'सहायता से संपर्क करें', ai_assistant: 'AI सहायक',
    admin_dashboard: 'एडमिन डैशबोर्ड', manage_suppliers: 'आपूर्तिकर्ता प्रबंधन',
    manage_products: 'उत्पाद प्रबंधन', manage_orders: 'ऑर्डर प्रबंधन',
    manage_users: 'उपयोगकर्ता प्रबंधन', content_approval: 'सामग्री स्वीकृति',
    violations: 'उल्लंघन', analytics: 'विश्लेषण', escrow: 'एस्क्रो',
    supplier_dashboard: 'आपूर्तिकर्ता डैशबोर्ड', my_products: 'मेरे उत्पाद',
    incoming_orders: 'आने वाले ऑर्डर', quotes: 'कोटेशन',
    customer_dashboard: 'मेरा डैशबोर्ड', my_orders: 'मेरे ऑर्डर',
    my_quotes: 'मेरे कोटेशन', shipment_tracking: 'शिपमेंट ट्रैकिंग',
    payment_methods: 'भुगतान के तरीक़े', my_cart: 'मेरी कार्ट',
    language: 'भाषा', choose_language: 'भाषा चुनें',
    main_site: 'मुख्य साइट', admin_panel: 'एडमिन पैनल', my_account: 'मेरा खाता',
    why_choose: 'OSESG क्यों चुनें?',
    show_original: 'मूल दिखाएँ', show_translation: 'अनुवाद दिखाएँ',
    translated_from: '{{lang}} से अनुवादित',
    translating: 'अनुवाद हो रहा है...',
    language_saved: 'भाषा प्राथमिकता सहेज ली गई',
    cnc_machines: 'CNC मशीनें', solar_panels: 'सोलर पैनल',
    forklifts: 'फ़ोर्कलिफ्ट', electronics: 'इलेक्ट्रॉनिक्स', medical_equipment: 'चिकित्सा उपकरण',
  }},
  it: { translation: {
    app_name: 'OSESG', tagline: 'La tua piattaforma globale di fiducia per il commercio B2B',
    tagline_long: "Entra in contatto con produttori verificati, ricevi preventivi competitivi e gestisci l'intera catena di fornitura in un unico posto.",
    search: 'Cosa stai cercando? Prova: macchina CNC, pannello solare...',
    search_products: 'Cerca prodotti...',
    login: 'Accedi', register: 'Registrati', logout: 'Esci',
    dashboard: 'Pannello di controllo', products: 'Prodotti', orders: 'Ordini',
    messages: 'Messaggi', notifications: 'Notifiche', settings: 'Impostazioni',
    profile: 'Profilo', save: 'Salva', cancel: 'Annulla', delete: 'Elimina',
    edit: 'Modifica', view: 'Visualizza', submit: 'Invia', approve: 'Approva',
    reject: 'Rifiuta', loading: 'Caricamento...', no_results: 'Nessun risultato',
    email: 'E-mail', password: 'Password', first_name: 'Nome', last_name: 'Cognome',
    phone: 'Telefono', country: 'Paese', city: 'Città', address: 'Indirizzo',
    forgot_password: 'Password dimenticata?', create_account: 'Crea account',
    already_have_account: 'Hai già un account?',
    all_products: 'Tutti i prodotti', product_details: 'Dettagli prodotto',
    request_quote: 'Richiedi preventivo', add_product: 'Aggiungi prodotto',
    product_code: 'Codice prodotto', price: 'Prezzo', moq: "Quantità minima d'ordine",
    lead_time: 'Tempi di consegna', specifications: 'Specifiche',
    applications: 'Applicazioni', advantages: 'Vantaggi',
    order_number: 'Numero ordine', order_status: 'Stato ordine', order_total: 'Totale',
    place_order: 'Invia ordine', track_order: 'Traccia ordine',
    send_message: 'Invia messaggio', type_message: 'Scrivi un messaggio...',
    contact_support: "Contatta l'assistenza", ai_assistant: 'Assistente IA',
    admin_dashboard: 'Pannello amministratore', manage_suppliers: 'Gestisci fornitori',
    manage_products: 'Gestisci prodotti', manage_orders: 'Gestisci ordini',
    manage_users: 'Gestisci utenti', content_approval: 'Approvazione contenuti',
    violations: 'Violazioni', analytics: 'Analisi', escrow: 'Deposito a garanzia',
    supplier_dashboard: 'Pannello fornitore', my_products: 'I miei prodotti',
    incoming_orders: 'Ordini in arrivo', quotes: 'Preventivi',
    customer_dashboard: 'La mia dashboard', my_orders: 'I miei ordini',
    my_quotes: 'I miei preventivi', shipment_tracking: 'Tracciamento spedizioni',
    payment_methods: 'Metodi di pagamento', my_cart: 'Il mio carrello',
    language: 'Lingua', choose_language: 'Scegli la lingua',
    main_site: 'Sito principale', admin_panel: 'Pannello admin', my_account: 'Il mio account',
    why_choose: 'Perché scegliere OSESG?',
    show_original: 'Mostra originale', show_translation: 'Mostra traduzione',
    translated_from: 'Tradotto da {{lang}}',
    translating: 'Traduzione in corso...',
    language_saved: 'Preferenza lingua salvata',
    cnc_machines: 'Macchine CNC', solar_panels: 'Pannelli solari',
    forklifts: 'Carrelli elevatori', electronics: 'Elettronica', medical_equipment: 'Apparecchiature mediche',
  }},
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'osesg_lang',
    },
  });

const applyDirection = (lng) => {
  const dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr';
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
    document.documentElement.dir = dir;
  }
};
applyDirection(i18n.language);
i18n.on('languageChanged', applyDirection);

export default i18n;
